import { requestRefMeta } from './data_loader/requestRefMeta'
import requestRefData from './data_loader/requestRefData'
import getNameById from './data_loader/getNameById'
import { REFER_TYPE } from './referType';
import referFilter from './data_loader/referFilter';
import {indexDB} from 'ynf-core-middleware'
import { handleValue } from './formatter'

export default class ReferCache {
    constructor (key) {
        this.key = key;
        this.db = null;
        this.tableName = 'refMeta' // indexDB表名
    }

    async init () {
        // 创建 数据库实例，初始化参数，拿到数据库实例
        this.db = await indexDB.init('referDataDB', 1, [{ tableName: this.tableName, options: { keyPath: "refCode", autoIncrement: false } }]);
        return this.db;
    }

    // 创建indexDB实例
    static async getInstance (key) {
        let cache = new ReferCache(key);
        let db = await cache.init();
        if (db) { // 连接成功
            return cache
        }
    }

    // indexDB存储数据
    set (key, value) {
        if (this.db) {
            this.db?.insert(this.tableName, { refCode: key, value })
        }
    }

    // indexDB读取数据
    get (key) {
        if (this.db) {
            return this.db.queryByPrimaryKey(this.tableName, key);
        }
    }

    deleteDB () {
        this.db.clearTable(this.tableName)
    }
    
    getData (props, referContext) {
        const data = this.getDataFromPageStore(props);
        if(data) {
            return data;
        } else {
            return this.getDataByMeta(props, referContext);
        } 
    }

    // 从pageCache中取name
    getDataFromPageStore (props) {
        let value = handleValue(props, props.value)
        let noName = false;
        let data = value.map(item => {
            item = props.pageStore.pageCache.cacheData.get(item[this.cEntityKeyFld]);
            if (!item) noName = true;
            return item;
        })
        if (noName) return false
        else return data
    }

    // pageCache缓存
    setDatatoPageStore (props, key, value) {
        props.pageStore.pageCache.cacheData.set(key, value);
    }

    processTreeData (data, treeData = []) {
        if (!data || !data.length) return;
        data.forEach(item => {
          treeData.push(item);
          if (!item.children) return;
          this.processTreeData(item.children, treeData);
        });
        return treeData
    }


    // 没有缓存时请求接口获取
    async getDataByMeta (props, referContext) {
        let flag = props.pageStore.pageCache.cacheData.get(`${props.refCode}_${this.id}`);
        if (flag) {
            let name = await this.getName(props);
            return name
        } else {
            this.setFlag(props)
            const meta = await this.getMeta(props, referContext)
            let data = await this.requestRefDataById(props, meta, referContext);
            const referType = REFER_TYPE.from(meta?.referType);
            const dataType = (referType !== REFER_TYPE.TREE && referType !== REFER_TYPE.TREE_LIST) ? 'grid' : 'tree';
            if (dataType === 'tree') {
                data = this.processTreeData(data);
            }
            let _data = Array.isArray(data) ? data : data?.recordList || [];
            _data.map(item => {
                this.setDatatoPageStore(props, item[this.cEntityKeyFld], item)
            })
            return _data;
        }
    }

    // 通过id获取name值
    requestRefDataById(props, meta, referContext) {
        // return getNameById(props, this.cEntityKeyFld, fullName)
        const { value, pageStore, filterConditions } = props;
        const billNo = pageStore.params.billNo;
        const busiObj = pageStore.params.busiObj;
        const domainKey = pageStore.params.domainKey;
        const serviceCode = pageStore.query.serviceCode;
        let _value = handleValue(props, value)
        let conditions = _value.map(item => {
            return { field: this.cEntityKeyFld, op: "eq", value1: item[this.cEntityKeyFld] }
        })
        // 组装过滤条件
        let condition = {
            isExtend: true,
            simpleVOs: [{ logicOp: "or", conditions }]
        };
        const referType = REFER_TYPE.from(meta?.referType);
        const dataType = (referType !== REFER_TYPE.TREE && referType !== REFER_TYPE.TREE_LIST) ? 'grid' : 'tree';
        const { conditionIsNull, isMasterOrg } = referContext;
        if (filterConditions) {
            condition = referFilter.handleFilterParams(filterConditions, conditionIsNull, condition, referContext);
        }
        let requestData = {
            refCode: props.refCode,
            condition: (referType !== REFER_TYPE.TREE && referType !== REFER_TYPE.TREE_LIST) ? condition : undefined,
            treeCondition: (referType === REFER_TYPE.TREE || referType === REFER_TYPE.TREE_LIST) ? condition : undefined,
            dataType,
            billnum: billNo,
            isMasterOrg: props.isMasterOrg
        }
        let params = {
            domainKey, 
            busiObj,
            datasource: props.dataSourceAlias,
            serviceCode,
            refCode: props.refCode,
            feV: 6
        };
        return requestRefData(requestData, params, referContext) 
    }

    // 获取参照显示值缓存数据
    getName (props, cEntityKeyFld) {
        return new Promise(res => {
            setTimeout(() => {
                let name = this.getDataFromPageStore(props, cEntityKeyFld)
                res(name)
            },  3000);
        })
    }

    getRefMeta(props, referContext) {
        const domainKey = props.pageStore.params.domainKey;
        const serviceCode = props.pageStore.query.serviceCode;
        return requestRefMeta(referContext, domainKey, serviceCode); // 请求getReferMeta接口
    }

    // 设置标识阻止后续相同请求
    setFlag (props) {
        const key = `${props.refCode}_${this.id}`;
        this.setDatatoPageStore(props, key, true);
        setTimeout(() => {
            this.setDatatoPageStore(props, key, false);
        }, 3000);
    }

    async getMeta(props, referContext) {
        if (referContext.metaDataObj.referType) {
            return referContext.metaDataObj;
        }
        // let _meta = await this.get(this.key);
        let _meta = this.getCacheWindow(this.key)
        let meta = {};
        if (_meta) {
            // meta = _meta.value;
            meta = _meta;
        } else {
            meta = await this.getRefMeta(props, referContext);
            // this.set(this.key, meta) // 先不存indexDB, 先挂到window上, 后续优化
            this.setCacheWindow(this.key, meta)
        }
        return meta;
    }

    setCacheWindow(key, meta) {
        window.ReferMetaTemporaryCache = {}
        window.ReferMetaTemporaryCache[key] = meta
    }

    getCacheWindow(key) {
        if (window.ReferMetaTemporaryCache) {
            return window.ReferMetaTemporaryCache[key]
        }
    }
}
